import React, { useState, useRef, useEffect } from 'react';
import { Document, Page } from 'react-pdf';
import '../styles/pdf-multiviewer.css';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist/build/pdf.worker.min.js`;

const PDFMultiviewer = ({ files }) => {
  const [currentPDF, setCurrentPDF] = useState(0);
  const [numPages, setNumPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [initialHeight, setInitialHeight] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const mainContainerRef = useRef(null);
  const isMobile = window.innerWidth < 768; // Or your breakpoint
  const pageWidth = isMobile ? window.innerWidth - 40 : 1140

  const handleDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setCurrentPage(1);
  };

  // Measure height once page is rendered
  const handlePageRenderSuccess = () => {
    if (mainContainerRef.current && initialHeight === 0) {
      const height = mainContainerRef.current.offsetHeight;
      setInitialHeight(height);
    }
  };

  const openModal = () => setIsModalOpen(true);
const closeModal = () => setIsModalOpen(false);

useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isModalOpen) {
        closeModal();
      }
    };
  
    if (isModalOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen]);


  return (
    <div
      className='pdf-multiviewer-container'
      ref={mainContainerRef}
      
    >
      {files && files.map((file, i) => {
        const isSelected = i === currentPDF;
        return (
          <div
            key={`pdf-multiviewer-${i}`}
            className={`pdf-multiviewer ${!isSelected ? 'hidden' : ''}`}
            style={{
                minHeight: initialHeight ? initialHeight + 'px' : 'auto',
                transition: 'min-height 0.3s ease',
              }}
          >
            {isSelected && (
              <div class='preview-pdf'>
                <Document
                  file={files[currentPDF].path}
                  onLoadSuccess={handleDocumentLoadSuccess}
                >
                  <Page
                    pageNumber={currentPage}
                    className="pdf-page"
                    width={306}
                    onRenderSuccess={handlePageRenderSuccess}
                  />
                </Document>
                <div className="navigation-buttons">
                  <button
                    disabled={currentPage <= 1}
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  >
                    <span>&lt;</span>
                  </button>
                  <span>
                    {currentPage} / {numPages}
                  </span>
                  <button
                    disabled={currentPage >= numPages}
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, numPages))}
                  >
                    <span>&gt;</span>
                  </button>
                </div>
              </div>
            )}
            {file?.desc && <div className='pdf-multiviewer-caption'>{file.desc}</div>}
            {i > 0 && (
              <button
                className='pdf-multiviewer-prev-button'
                onClick={() => setCurrentPDF(prev => Math.max(prev - 1, 0))}
              >
                &lt;
              </button>
            )}
            {i < files.length - 1 && (
              <button
                className='pdf-multiviewer-next-button'
                onClick={() => setCurrentPDF(prev => Math.min(prev + 1, files.length - 1))}
              >
                &gt;
              </button>
            )}
            <button onClick={openModal} className="open-in-modal-btn">Open Document</button>
            {isModalOpen && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <button className="close-modal" onClick={closeModal}>Close</button>
                    <Document file={files[currentPDF].path} onLoadSuccess={(params) => setNumPages(params.numPages)}>
                    {Array.from(new Array(numPages), (el, index) => (
                        <Page key={`page_${index + 1}`} pageNumber={index + 1} width={pageWidth} />
                    ))}
                    </Document>
                    </div>
                </div>
                )}
          </div>
        );
      })}
    </div>
  );
};

export default PDFMultiviewer;
